<template>
  <div class="component-interaction-trigger-components">
    <div class="trigger-condition">以下条件的关系为<el-button @click="interaction.relation=!interaction.relation">{{interaction.relation?'且':'或'}}</el-button></div>
    <div class="trigger-components" v-for="(triggerComponent,index) in interaction.triggerComponents" :key="index">
      <el-form-item class="component-condition mr20" :prop="'triggerComponents.'+index+'.triggerComponent'" :rules="{required: true, message: '请选择控件', trigger: 'change'}">
        <public-combobox
          @change="optionChange($event,newOptions,triggerComponent,interaction)"
          v-model="triggerComponent.triggerComponent" :options="newOptions" :computedByLabel="{methods: 'component-interaction', isProcess}" :placeholder="'请选择控件'"></public-combobox>
      </el-form-item>
      <el-form-item class="component-condition mr20" :prop="'triggerComponents.'+index+'.triggerType'" :rules="{required: true, message: '请选择运算符', trigger: 'change'}">
        <el-select v-model="triggerComponent.triggerType" placeholder="请选择运算符" filterable clearable>
          <template v-for="(option, index) in triggerOptions">
            <el-option
              v-if="optionCheck(option,triggerComponent.componentType)"
              :key="index"
              :label="option.name"
              :value="option.value">
            </el-option>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item v-if="triggerComponent.triggerType!=='空'&&triggerComponent.triggerType!=='非空'" class="component-condition" :prop="'triggerComponents.'+index+'.compareVal'" :rules="{required: true, message: '请输入对比值', trigger: 'blur'}">
        <el-input class="compare-val" placeholder="请输入对比值" v-model="triggerComponent.compareVal"/>
      </el-form-item>
      <span class="close-condition" @click="delTrigger(interaction.triggerComponents, index)">x</span>
    </div>
    <div class="add-trigger"><i class="el-icon-plus"></i><span @click="addTrigger(interaction.triggerComponents)">添加条件</span></div>
  </div>
</template>

<script>
import publicCombobox from '@/components/public/public-combobox.vue'

export default {
  name: 'component-interaction-trigger-components',
  props: {
    interaction: Object,
    options: Array,
    isProcess: Boolean
  },
  components: {
    publicCombobox
  },
  data () {
    return {
      triggerOptions: [
        {name: '=', value: '='},
        {name: '!=', value: '!='},
        {name: '>', value: '>'},
        {name: '<', value: '<'},
        {name: '包含', value: 'includes'},
        {name: '空', value: '空'},
        {name: '非空', value: '非空'}
      ]
    }
  },
  methods: {
    addTrigger (arr) {
      arr.push({triggerComponent: '', triggerType: '', compareVal: ''})
    },
    delTrigger (arr, index) {
      arr.splice(index, 1)
    },
    optionChange (value, options, triggerComponent, interaction) {
      for (let option of options) {
        if (option.id === value) {
          triggerComponent.componentType = option.componentType
          break
        }
      }
      triggerComponent.triggerType = ''
      triggerComponent.compareVal = ''
    },
    optionCheck (option, componentType) {
      let flag = true
      let type = option.value
      if (componentType === 'rc-currency') {
        if (type === 'includes') {
          flag = false
        }
      } else if (componentType === 'rc-radio') {
        if (['<', '>'].includes(type)) {
          flag = false
        }
      } else if (componentType === 'rc-checkbox') {
        if (['<', '>'].includes(type)) {
          flag = false
        }
      } else if (componentType === 'rc-uuid') {
        if (['<', '>'].includes(type)) {
          flag = false
        }
      } else if (componentType === 'rc-phone') {
        if (['<', '>'].includes(type)) {
          flag = false
        }
      } else if (componentType === 'rc-login-user') {
        if (['<', '>'].includes(type)) {
          flag = false
        }
      } else if (componentType === 'rc-password') {
        if (['<', '>'].includes(type)) {
          flag = false
        }
      }
      //  超链接功能剔除，不归档，会出现很多归档相关bug
      // else if (componentType === 'rc-hyperlink') {
      //   if (['<', '>'].includes(type)) {
      //     flag = false
      //   }
      // }
      //  富文本框功能剔除
      // else if (componentType === 'rc-rich-box') {
      //   if (['includes', '空', '非空'].includes(type)) {
      //     flag = false
      //   }
      // }
      return flag
    }
  },
  computed: {
    newOptions () {
      //  49期需求。控件交互新增控件，富文本框。条件不可选（没意义，无法比较）。但又可执行。所以在条件下拉框中剔除富文本框
      return this.options.filter(el => el.componentType !== 'rc-rich-box')
    }
  }
}
</script>

<style lang="scss">
.component-interaction-trigger-components{
  .trigger-condition {
    font-size: 12px;
    color: #DBDBDB;
    text-align: right;
    margin-bottom: 12px;
    .el-button {
      padding: 3px 5px;
      margin-left: 20px;
    }
  }
  .trigger-components{
    position: relative;
    .component-condition {
      .el-select,.el-select>.el-input{
        width: 140px;
      }
      .el-input {
        width: 120px;
      }
    }
    &:hover{
      .close-condition {
        display: inline-block;
      }
    }
    .close-condition {
      display: none;
      width: 12px;
      height:12px;
      font-size: 10px;
      border-radius: 50%;
      background: transparent;
      text-align: center;
      line-height: 8px;
      cursor: pointer;
      color: #C2C3C4;
      position: absolute;
      right: 0;
      top: 43%;
      margin-top: -6px;
      &:hover {
        background: #FB9391;
        color: #fff;
      }
      &:active {
        background: #EE5451;
        color: #fff;
      }
    }
  }
  .mr20 {
    margin-right: 20px;
  }
  .add-trigger {
    width: 70px;
    margin: 0 auto;
    color: #54ABF1;
    font-size: 12px;
    cursor: pointer;
    i {
      font-size: 12px;
    }
    span {
      margin-left: 10px;
      font-size: 12px;
    }
    &:active{
      color: #2480CA;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/componentInteractionAttrChildren/component-interaction-trigger-components.vue